<template>
    <ShowHistory :isAdHistory="false"></ShowHistory>
</template>

<script>
    import ShowHistory from "./ShowHistory";

    export default {
        name: "OpHistory",
        components: {ShowHistory},
        data() {
            return {
            }
        },
    }
</script>

<style scoped lang="scss">
</style>